"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accessorial = void 0;
var Accessorial;
(function (Accessorial) {
    Accessorial["Alcohol"] = "alcohol";
    Accessorial["Appointment"] = "appointment";
    Accessorial["CrossDock"] = "crossDock";
    Accessorial["HazardousMaterials"] = "hazmat";
    Accessorial["HomeDelivery"] = "homeDelivery";
    Accessorial["Inside"] = "inside";
    Accessorial["LiftgateRequired"] = "liftgate";
    Accessorial["LimitedAccess"] = "limitedAccess";
    Accessorial["ResidentialLocation"] = "residential";
    Accessorial["SortOrSegregate"] = "sortSeg";
    Accessorial["Tobacco"] = "tobacco";
    Accessorial["Tradeshow"] = "tradeshow";
    Accessorial["CFS"] = "cfs";
    Accessorial["LocalInsideDelivery"] = "localInsideDelivery";
})(Accessorial = exports.Accessorial || (exports.Accessorial = {}));
//# sourceMappingURL=accessorials.js.map